import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';
import { Button } from '@mui/material';
import { customStyles } from '../styles';

// Valores por default: se usan antes de iniciar sesión (GET /info requiere sesión)
// o si la carga de redes sociales falla.
const DEFAULT_PHONE = '3331674506'
const DEFAULT_LOCAL_NUMBER = '55-44-40-16-35'
const DEFAULT_MAIL = 'atencioncliente@globalgas.com.mx'
const DEFAULT_WEBSITE = 'https://globalgas.mx/location/?region=jalisco'

export const phone_number = DEFAULT_PHONE
export const wpLink = `https://wa.me/${DEFAULT_PHONE}`

export const iconStyle = {
  fontSize: 25,
  color: customStyles.colors.main
}

const toSupportContact = (socialNetworks) => ({
  phone: socialNetworks?.whatsapp || DEFAULT_PHONE,
  localNumber: socialNetworks?.phone || DEFAULT_LOCAL_NUMBER,
  mail: socialNetworks?.email || DEFAULT_MAIL,
  website: socialNetworks?.web || DEFAULT_WEBSITE,
})

export const buildSupportOptions = (socialNetworks) => {
  const { phone, localNumber, mail, website } = toSupportContact(socialNetworks)
  return [
    {
      component: <Button icon={<WhatsAppIcon />} text={phone} size="100%" sharp link={`https://wa.me/${phone}`} />
    },
    {
      component: <Button icon={<LocalPhoneIcon />} text={localNumber} size="100%" sharp link={`tel:${localNumber}`} />
    },
    {
      component: <Button icon={<EmailIcon />} text={mail} size="100%" sharp link={`mailto:${mail}`} />
    },
    {
      component: <Button icon={<LanguageIcon />} text={website} size="100%" sharp link={website} />
    },
  ]
}

export const buildSupportOPT = (socialNetworks) => {
  const { phone, localNumber, mail, website } = toSupportContact(socialNetworks)
  return [
    {
      icon: <WhatsAppIcon sx={iconStyle}/>,
      label: phone,
      link: `https://wa.me/${phone}`
    },
    {
      icon: <LocalPhoneIcon sx={iconStyle}/>,
      label: localNumber,
      link: `tel:${localNumber}`,
    },
    {
      icon: <EmailIcon sx={iconStyle}/>,
      label: mail,
      link: `mailto:${mail}`,
    },
    {
      icon: <LanguageIcon sx={iconStyle}/>,
      label: website,
      link: website,
    },
  ]
}
